import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.text
    ? _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _c(
            VIcon,
            {
              staticClass: "mr-4",
              attrs: { size: "20", color: "text-secondary" },
            },
            [_vm._v("\n    " + _vm._s(_vm.icon) + "\n  ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-body-2 text-secondary--text first-uppercase" },
            [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }